import React from "react";

function ProductsSection() {
  return (
    <section className="shop1-con prod position-relative">
      <div className="container-fluid p-5">

        {/* ROW 1 */}
        <div className="row shop-products-con">
          <ProductCard image="./assets/product-images/Pistachio.png" name="Pistachio" desc="A rich and creamy scoop packed with the royal taste of roasted pistachios." boxClass="box1" />
          <ProductCard image="./assets/product-images/Hazlenut.png" name="Hazelnut" desc="Smooth, nutty indulgence with the comforting flavour of premium hazelnuts." boxClass="box2" />
          <ProductCard image="./assets/product-images/Cashew.png" name="Cashew" desc="Silky gelato blended with the naturally buttery goodness of cashews." boxClass="box3" />
          <ProductCard image="./assets/product-images/almond.png" name="Almond" desc="A delicately nutty delight with the wholesome richness of almonds." boxClass="box4" />
        </div>

        {/* ROW 2 */}
        <div className="row shop-products-con mt-3">
          <ProductCard image="./assets/product-images/Peanut Butter.png" name="Peanut Butter" desc="Creamy, bold, and irresistibly nutty with a perfectly smooth finish." boxClass="box5" />
          <ProductCard image="./assets/product-images/Biscoff.png" name="Biscoff" desc=" Creamy gelato swirled with the caramelised crunch of Biscoff biscuits." boxClass="box6" />
          <ProductCard image="./assets/product-images/Choco Hazlennut.png" name="Choco Hazelnut" desc="A luxurious blend of rich chocolate and roasted hazelnut goodness." boxClass="box5" />
          <ProductCard image="./assets/product-images/Snickers.png" name="Snickers" desc="A decadent scoop inspired by the iconic mix of chocolate, nuts, and caramel." boxClass="box1" />
        </div>

        {/* ROW 3 */}
        <div className="row shop-products-con mt-3">
          <ProductCard image="./assets/product-images/Plain Chocolate.png" name="Plain Chocolate" desc="Pure chocolate indulgence with a rich and classic flavour." boxClass="box5" />
          <ProductCard image="./assets/product-images/Strawberry.png" name="Strawberry" desc="A refreshing burst of sweet strawberries in every creamy scoop." boxClass="box6" />
          <ProductCard image="./assets/product-images/Jamun.png" name="Jamun" desc="A unique fruity indulgence with the bold and nostalgic taste of jamun." boxClass="box5" />
          <ProductCard image="./assets/product-images/Blueberry.png" name="Blueberry" desc="Smooth and fruity gelato infused with the sweet-tangy charm of blueberries." boxClass="box1" />
        </div>

        {/* ROW 4 */}
        <div className="row shop-products-con mt-3">
          <ProductCard image="./assets/product-images/Chiiku.png" name="Chikoo" desc="Creamy perfection blended with the naturally sweet flavour of ripe chikoo." boxClass="box5" />
          <ProductCard image="./assets/product-images/Tiramisu.png" name="Tiramisu" desc="A luxurious Italian classic layered with creamy coffee delight." boxClass="box5" />
          <ProductCard image="./assets/product-images/Mango Sorbet.png" name="Mango Sorbet" desc="A light and refreshing tropical escape bursting with mango freshness." boxClass="box5" />
          <ProductCard image="./assets/product-images/Coffee.png" name="Coffee" desc="Bold, smooth, and refreshing with the rich aroma of freshly brewed coffee." boxClass="box1" />
        </div>

        {/* ROW 5 */}
        <div className="row shop-products-con mt-3"> 
          <ProductCard image="./assets/product-images/Mango.png" name="Mango" desc="Tropical richness crafted with the luscious taste of ripe mangoes." boxClass="box5" />
          <ProductCard image="./assets/product-images/Milk Chocolate.png" name="Milk Chocolate" desc="Creamy milk chocolate bliss made for every chocolate lover." boxClass="box5" />
          <ProductCard image="./assets/product-images/Coconut & Custard Apple.png" name="Tender Coconut" desc="Fresh, creamy gelato made with real tender coconut and soft coconut bits for a naturally refreshing tropical experience." boxClass="box5"  />
          <ProductCard image="./assets/product-images/Coconut & Custard Apple.png" name="Custard Apple" desc="Silky, creamy gelato infused with the rich sweetness of ripe custard apple for a smooth, fruity indulgence." boxClass="box5"  />
          
        </div>

      </div>
    </section> 
  );
}

// ✅ Reusable Product Card Component
function ProductCard({ image, name, desc, boxClass }) {
  return (
    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
      <div className="classic-box hover-card">
        <div className={`classic_image_box ${boxClass}`}>
          <img src={image} alt={name} />
        </div>
        <div className="hover-content">
          <h6 className="hover-title">{name}</h6>
          <p className="hover-desc">{desc}</p>
        </div>
      </div>
    </div>
  );
}

export default ProductsSection;